module.exports = __webpack_public_path__ + "static/media/IIIh.ba6bb57b.png";